@if (callback.context()) {
  <a
    href="#"
    (click)="open($event)"
    class="flex items-center gap-2 py-3 lg:py-0 text-sm font-bold text-cp-primary-100 underline whitespace-nowrap"
  >
    Rückruf vereinbaren
    <mat-icon svgIcon="cp-phone" class="!w-5 !h-5" />
  </a>
}
